import React from 'react';
import { makeStyles } from '@material-ui/styles';
import CloseIcon from '@material-ui/icons/Close';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Dialog, DialogActions, DialogContent, IconButton } from '@material-ui/core';

interface Props {
  open: boolean;
  url: string | null;
  onClose: () => void;
}

const useStyles = makeStyles(() => ({
  Content: {
    width: '1024px',
    height: '600px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  Image: {
    display: 'block',
    maxWidth: '100%',
    maxHeight: '550px',
    width: 'auto',
    height: 'auto'
  }
}));

export const ImagePreview: React.FC<Props> = ({ url, open, onClose }: Props) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <DialogActions>
        <IconButton onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogActions>

      <DialogContent className={classes.Content}>
        {url ? <LazyLoadImage className={classes.Image} src={url} /> : null}
      </DialogContent>
    </Dialog>
  );
};
